module.exports = __webpack_public_path__ + "static/media/22ESCWA22.b7e6847c.jpg";